/* eslint-disable mastery/known-imports */
import { faLinkedin } from '@masterysystems/free-brands-svg-icons';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faCircleCheck,
  faCircleLocationArrow,
  faCopy,
  faFilePdf,
  faMapLocation,
  faPaw,
  faShieldCheck,
  faShip,
  faUserGroup,
} from '@masterysystems/pro-light-svg-icons';
import {
  faArrowDownToLine,
  faArrowProgress,
  faArrowTurnDown,
  faArrowUpFromLine,
  faArrowUpRightFromSquare,
  faArrowsMaximize,
  faArrowsRotate,
  faAward,
  faBan,
  faBars,
  faBoxOpen,
  faBuilding,
  faBullseyeArrow,
  faCalendar,
  faCalendarDays,
  faCartShopping,
  faCheck,
  faCircle,
  faCircleCaretDown,
  faCircleDollar,
  faCircleExclamation,
  faCircleInfo,
  faCircleQuestion,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faClockTwelve,
  faClone,
  faCloudArrowDown,
  faCloudArrowUp,
  faCommentDots,
  faCommentLines,
  faCommentPen,
  faCompass,
  faCompress,
  faDash,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeCircleCheck,
  faExpand,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowDown,
  faFileArrowUp,
  faFileCheck,
  faFileExcel,
  faFileExport,
  faFileInvoiceDollar,
  faFileSignature,
  faFilter,
  faFilters,
  faFlag,
  faFlashlight,
  faFloppyDisk,
  faFolder,
  faGear,
  faGlobe,
  faGripVertical,
  faHandHolding,
  faHouse,
  faIndustryWindows,
  faIslandTropical,
  faLineColumns,
  faLink,
  faList,
  faLocationDot,
  faLocationPin,
  faLock,
  faMagnifyingGlass,
  faMailbox,
  faMoneyBill,
  faMoon,
  faMugHot,
  faPaperclip,
  faPen,
  faPhone,
  faPig,
  faPlane,
  faPlay,
  faPlus,
  faRoad,
  faRoute,
  faRulerTriangle,
  faScaleUnbalancedFlip,
  faShareNodes,
  faSignalStream,
  faSparkles,
  faSplit,
  faStar,
  faStop,
  faStopwatch,
  faTableColumns,
  faTemperatureList,
  faThumbsDown,
  faThumbsUp,
  faTimer,
  faTrainTrack,
  faTrash,
  faTrashList,
  faTriangleExclamation,
  faTruck,
  faTruckFast,
  faTruckMoving,
  faTruckRampBox,
  faUnlockKeyhole,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserCheck,
  faUsers as faUsersGroup,
  faWarehouseFull,
  faWindowRestore,
  faWineBottle,
  faXmark,
} from '@masterysystems/pro-regular-svg-icons';
import {
  faArrowDown,
  faArrowLeft,
  faArrowLeftFromLine,
  faArrowRight,
  faArrowUp,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCircleCheck as faCircleCheckSolid,
  faCircleXmark,
  faCodeCompare,
  faEllipsis,
  faForklift,
  faListTree,
  faLocationCrosshairs,
  faMicrophone,
  faPaperPlane,
  faRobot,
  faSlash,
  faCircleExclamation as faSolidCircleExclamation,
  faCircleInfo as faSolidCircleInfo,
  faCircleQuestion as faSolidCircleQuestion,
  faEnvelope as faSolidEnvelope,
  faWarehouseFull as faSolidFaWarehouseFull,
  faFolder as faSolidFolder,
  faLock as faSolidLock,
  faPhone as faSolidPhone,
  faStar as faSolidStar,
  faThumbsDown as faSolidThumbsDown,
  faThumbsUp as faSolidThumbsUp,
  faTriangleExclamation as faSolidTriangleExclamation,
  faTruckMoving as faSolidTruckMoving,
  faTruckRampBox as faSolidTruckRampBox,
  faUser as faSolidUser,
  faSpinner,
  faSteeringWheel,
  faTruckFlatbed,
} from '@masterysystems/pro-solid-svg-icons';

// ts-unused-exports:disable-next-line
export const iconMap = {
  angleDown: faAngleDown,
  angleLeft: faAngleLeft,
  angleRight: faAngleRight,
  angleUp: faAngleUp,
  arrowDown: faCaretDown,
  arrowDownSolid: faArrowDown,
  arrowLeft: faCaretLeft,
  arrowLeftSolid: faArrowLeft,
  arrowLeftFromLineSolid: faArrowLeftFromLine,
  arrowMaximize: faArrowsMaximize,
  arrowProgress: faArrowProgress,
  arrowRight: faCaretRight,
  arrowRightSolid: faArrowRight,
  arrowTurnDown: faArrowTurnDown,
  arrowUp: faCaretUp,
  arrowUpSolid: faArrowUp,
  award: faAward,
  balanceScaleRight: faScaleUnbalancedFlip,
  ban: faBan,
  bars: faBars,
  boat: faShip,
  boxOpen: faBoxOpen,
  building: faBuilding,
  bullsEyeArrow: faBullseyeArrow,
  calendar: faCalendarDays,
  calendarEmpty: faCalendar,
  caretCircleDown: faCircleCaretDown,
  check: faCheck,
  checkCircleSolid: faCircleCheckSolid,
  checkCircle: faCircleCheck,
  circle: faCircle,
  circleDollar: faCircleDollar,
  circleLocationArrow: faCircleLocationArrow,
  clipboard: faClipboard,
  clock: faClock,
  clockTwelve: faClockTwelve,
  clone: faClone,
  codeCompare: faCodeCompare,
  column: faTableColumns,
  commentDots: faCommentDots,
  commentLinesRegular: faCommentLines,
  commentPen: faCommentPen,
  compass: faCompass,
  compress: faCompress,
  copy: faCopy,
  download: faArrowDownToLine,
  drag: faGripVertical,
  edit: faPen,
  ellipsis: faEllipsis,
  envelope: faEnvelope,
  envelopeCircleCheck: faEnvelopeCircleCheck,
  envelopeSolid: faSolidEnvelope,
  exclamationCircle: faCircleExclamation,
  exclamationCircleSolid: faSolidCircleExclamation,
  exclamationTriangle: faTriangleExclamation,
  exclamationTriangleSolid: faSolidTriangleExclamation,
  expand: faExpand,
  expandAlt: faUpRightAndDownLeftFromCenter,
  eye: faEye,
  eyeSlash: faEyeSlash,
  facility: faWarehouseFull,
  file: faFile,
  fileCheck: faFileCheck,
  fileCloudDownload: faCloudArrowDown,
  fileCloudUpload: faCloudArrowUp,
  fileDownload: faFileArrowDown,
  fileExcel: faFileExcel,
  fileExport: faFileExport,
  fileInvoiceDollar: faFileInvoiceDollar,
  filePdf: faFilePdf,
  fileUpload: faFileArrowUp,
  filterSolid: faFilter,
  flag: faFlag,
  folder: faFolder,
  folderSolid: faSolidFolder,
  forkLift: faForklift,
  gear: faGear,
  globe: faGlobe,
  handHolding: faHandHolding,
  history: faClockRotateLeft,
  home: faHouse,
  industry: faIndustryWindows,
  infoCircle: faCircleInfo,
  infoCircleSolid: faSolidCircleInfo,
  islandTropical: faIslandTropical,
  lineColumnsReg: faLineColumns,
  link: faLink,
  linkedin: faLinkedin,
  linkExternal: faArrowUpRightFromSquare,
  list: faList,
  lockSolid: faSolidLock,
  locationMap: faMapLocation,
  lock: faLock,
  mailBox: faMailbox,
  mapMarker: faLocationDot,
  mapMarkerEmpty: faLocationPin,
  moon: faMoon,
  moneyBill: faMoneyBill,
  mugHotLight: faMugHot,
  order: faCartShopping,
  paperClip: faPaperclip,
  partialCheck: faDash,
  paperPlane: faPaperPlane,
  paw: faPaw,
  phone: faPhone,
  phoneSolid: faSolidPhone,
  pig: faPig,
  plane: faPlane,
  play: faPlay,
  plus: faPlus,
  question: faCircleQuestion,
  questionSolid: faSolidCircleQuestion,
  refresh: faArrowsRotate,
  road: faRoad,
  route: faRoute,
  robot: faRobot,
  microphone: faMicrophone,
  rulerTriangle: faRulerTriangle,
  save: faFloppyDisk,
  search: faMagnifyingGlass,
  sharedNodes: faShareNodes,
  sharpFilters: faFilters,
  shieldCheck: faShieldCheck,
  shipping: faTruckFast,
  signalStream: faSignalStream,
  signature: faFileSignature,
  slash: faSlash,
  sparkles: faSparkles,
  spinner: faSpinner,
  split: faSplit,
  spotlight: faFlashlight,
  star: faStar,
  starSolid: faSolidStar,
  steeringWheel: faSteeringWheel,
  stop: faStop,
  stopWatch: faStopwatch,
  temperatureList: faTemperatureList,
  thumbsUp: faThumbsUp,
  thumbsUpSolid: faSolidThumbsUp,
  thumbsDown: faThumbsDown,
  thumbsDownSolid: faSolidThumbsDown,
  timer: faTimer,
  tracking: faLocationCrosshairs,
  trainTrack: faTrainTrack,
  trash: faTrash,
  trashList: faTrashList,
  treeList: faListTree,
  truck: faTruck,
  truckLoading: faTruckRampBox,
  truckLoadingSolid: faSolidTruckRampBox,
  truckMoving: faTruckMoving,
  truckMovingSolid: faSolidTruckMoving,
  warehouseFullSolid: faSolidFaWarehouseFull,
  truckFlatbed: faTruckFlatbed,
  unlockKeyhole: faUnlockKeyhole,
  upload: faArrowUpFromLine,
  user: faUser,
  userCheck: faUserCheck,
  userGroup: faUserGroup,
  userSolid: faSolidUser,
  usersGroup: faUsersGroup,
  verticalEllipsis: faEllipsisVertical,
  windows: faWindowRestore,
  wineBottle: faWineBottle,
  x: faXmark,
  xCircle: faCircleXmark,
};
